"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = mixins;

var _constructor = _interopRequireDefault(require("../../../constants/constructor"));

/* istanbul ignore file */
// constants

/**
 * Permet de décorer une classe avec les méthodes d’autres classes.
 * Immite le comportement de traits dans d’autres langages.
 * @param  {...any} decoratedClasses
 */
function mixins(...decoratedClasses) {
  const TempClass = class {
    constructor(...args) {
      const self = this;
      decoratedClasses.forEach(function (DecoratedClass) {
        if ("function" === typeof DecoratedClass.prototype[_constructor.default]) {
          DecoratedClass.prototype[_constructor.default].apply(self, args);
        }
      });
    }

  };
  decoratedClasses.forEach(function (DecoratedClass) {
    if (Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(DecoratedClass))) !== null) {
      throw new SyntaxError("A decorated class must not have an inherited class when using function mixins.");
    }

    [].concat(Object.getOwnPropertyNames(DecoratedClass.prototype), Object.getOwnPropertySymbols(DecoratedClass.prototype)).forEach(function (propertyName) {
      if (propertyName !== "constructor") {
        Object.defineProperty(TempClass.prototype, propertyName, Object.getOwnPropertyDescriptor(DecoratedClass.prototype, propertyName));
      }
    });
    [].concat(Object.getOwnPropertyNames(DecoratedClass), Object.getOwnPropertySymbols(DecoratedClass)).forEach(function (propertyName) {
      if (!["length", "name", "prototype"].includes(propertyName)) {
        Object.defineProperty(TempClass, propertyName, Object.getOwnPropertyDescriptor(DecoratedClass, propertyName));
      }
    });
  });
  return TempClass;
}